import { Icon } from '@ps/sports-ui-component-library';
import { Clock } from '@ps/sports-ui-component-library/icons/Clock';
import { InPlay } from '@ps/sports-ui-component-library/icons/InPlay';
import { format } from 'date-fns';
import React from 'react';

import styles from './TodaysEventLink.scss';

interface Props {
  isInPlay: boolean;
  isEventToday: boolean;
  parsedEventStartTime: Date;
  eventName: string;
}

const TodaysEventLink: React.FC<Props> = ({
  isInPlay,
  isEventToday,
  parsedEventStartTime,
  eventName
}) => {
  if (!isInPlay && isEventToday) {
    return (
      <div className={styles.upcomingLink}>
        <span className={styles.upcomingEventName}>{eventName}</span>
        <div
          className={styles.upcomingLinkWrapper}
          data-testid="quick-switcher-event-upcoming-icon"
        >
          <Icon icon={Clock} size="sm" className={styles.upcomingLinkIcon} />
          <span className={styles.upcomingLinkText}>{format(parsedEventStartTime, 'HH:mm')}</span>
        </div>
      </div>
    );
  }
  return (
    <div className={styles.inPlayLink}>
      <span className={styles.inPlayEventName}>{eventName}</span>
      <div className={styles.inPlayLinkIconWrapper} data-testid="quick-switcher-event-in-play-icon">
        <Icon icon={InPlay} size="sm" className={styles.inPlayLinkIcon} />
      </div>
    </div>
  );
};

export default TodaysEventLink;
